import { ClassNameMap } from '@material-ui/styles';
import React, { CSSProperties } from 'react';

export type TableClassKeyType = 'tableItem' | 'table';

export type TableItemClassKeyType = 'root';

export interface ITableCommonProps {
  collapsedContent?: (x: any) => React.ReactNode;
  handleRowClick?: (event: any, x?: any) => void;
  columns: IColumn[];
  tableItemGridTemplate: string;
  keyName: string;
  expandOnClick?: boolean;
  itemStyle?: (x: any) => CSSProperties;
}

export interface ITable extends ITableCommonProps {
  items: any[];
  classes?: Partial<ClassNameMap<TableClassKeyType>>;
}

export interface ITableItem extends ITableCommonProps {
  item: any;
  classes?: Partial<ClassNameMap<TableItemClassKeyType>>;
}

export interface ITableFooter extends IPageMetaData {
  canLoadMore: boolean;
  handleLoadMore: () => void;
  loading: boolean;
  label?: string;
}

export interface IColumn {
  label: string;
  value: string;
  columnSortingId?: string;
  transform?: (x: any) => string;
  columnContent?: (x: any, isExpanded?: boolean) => React.ReactNode;
  truncated?: boolean;
  styles?: CSSProperties | undefined;
}

export type ISorting = {
  field: string;
  direction: OrderingDirection;
} | null;

export interface ITableHeader {
  setSortingConditions?: (field: string) => void;
  sorting?: ISorting;
  idSuffix: string;
  columns: IColumn[];
  tableItemGridTemplate: string;
}

export interface IPageMetaData {
  currentItems: number;
  totalItems: number;
}

export enum OrderingDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}
